module.exports = __webpack_public_path__ + "static/media/fees.455f6419.svg";